import { AxiosResponse } from "axios";
import { CommodityMapper } from "@/data/persistences/mappers/CommodityMapper";
import { CommodityList } from "@/domain/entities/Commodity";

// CommodityV4Mapper — clone/delegate CommodityMapper sementara untuk response existing
export class CommodityV4Mapper {
  private delegate = new CommodityMapper();

  public convertCommodityDataFromApi(res: AxiosResponse<any>): CommodityList {
    return this.delegate.convertCommodityDataFromApi(res);
  }
}
